import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { AuthGuard } from './services/auth-guard.service';


const routes: Routes = [

{ path: 'settings', 
canActivate: [AuthGuard],
canActivateChild: [AuthGuard],


loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule) },

{ path: '', loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule) }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
